// External Dependencies:
import React from 'react'
import { connect } from 'react-redux'

// Internal Dependencies:
import MediaPlayer from 'church-theme-library/components/MediaPlayer/MediaPlayer'
import Editable from 'church-theme-library/components/Editable/Editable'

class SermonVideo extends React.Component {
	render() {
		const { translate, page } = this.props

		if ( ! page || ! page.is_sermon ) {
			return null
		}

		return (
			<div className="sermon-media">
				<Editable
					id="set_sermon_file"
					element="div"
				>
					<MediaPlayer
						url={ page.sermon_url }
						file={ page.sermon_file }
						type={ page.sermon_file_type }
						image={ page.featured_image }
					/>
				</Editable>
			</div>
		)
	}
}

const mapStateToProps = ( state, ownProps ) => {
	return {
		page: state.page.selected
	}
}

export default connect( mapStateToProps )( SermonVideo )
